export const space = [0, 4, 8, 16, 32, 64, 128, 256, 512]
export const size = [0, 4, 8, 16, 28, 32, 40, 52, 64, 128, 256, 280, 512]
